module.exports = __webpack_public_path__ + "images/landing/state-pages/city-scape-desktop.svg";